import { useState } from "react";

export default function AgeGate() {
  const [verified, setVerified] = useState(() => localStorage.getItem("fd_age_ok") === "yes");
  const [denied, setDenied] = useState(false);

  if (verified) return null;

  const accept = () => {
    localStorage.setItem("fd_age_ok", "yes");
    setVerified(true);
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-ink/95 p-4 backdrop-blur-sm grain"
      role="dialog"
      aria-modal="true"
      aria-label="Age verification"
      data-testid="age-gate-modal"
    >
      <div className="w-full max-w-md border border-white/10 bg-[#161616] p-8 text-center shadow-[0_16px_48px_rgba(0,0,0,0.5)] sm:p-10">
        <img src="/logo.webp" alt="Farmacy District DC" className="mx-auto mb-8 h-12 w-auto" />
        {!denied ? (
          <>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-lime">Adults Only</p>
            <h2 className="mt-3 font-display text-3xl font-black tracking-tight text-white">
              Are you 21 or older?
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-neutral-400">
              Farmacy District DC is for adults 21+. Please confirm your age to enter.
            </p>
            <div className="mt-8 grid gap-3">
              <button
                data-testid="age-gate-yes-button"
                onClick={accept}
                className="w-full rounded-full bg-brand-lime py-3.5 text-sm font-bold tracking-wide text-brand-ink transition-[background-color,transform] duration-200 hover:bg-brand-limehover hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-brand-lime"
              >
                YES, I'M 21+
              </button>
              <button
                data-testid="age-gate-no-button"
                onClick={() => setDenied(true)}
                className="w-full rounded-full border border-white/20 py-3.5 text-sm font-bold tracking-wide text-white transition-colors duration-200 hover:border-white/50 focus:outline-none focus:ring-2 focus:ring-white/40"
              >
                NO, I'M UNDER 21
              </button>
            </div>
            <p className="mt-6 text-[11px] leading-relaxed text-neutral-500">
              Initiative 71 compliant gifting. For use only by adults 21 years of age and older.
            </p>
          </>
        ) : (
          <>
            <h2 className="font-display text-2xl font-black text-white" data-testid="age-gate-denied-message">
              You must be 21+ to enter
            </h2>
            <p className="mt-3 text-sm text-neutral-400">
              Come back and see us when you're of legal age.
            </p>
            <a
              href="https://www.google.com"
              data-testid="age-gate-exit-link"
              className="mt-8 inline-block rounded-full border border-white/20 px-8 py-3 text-sm font-bold text-white transition-colors hover:border-white/50"
            >
              LEAVE SITE
            </a>
          </>
        )}
      </div>
    </div>
  );
}
